export const TICKETS_ACTION_TYPES = {
  FETCH_TICKETS_START: 'tickets/FETCH_TICKETS_START',
  FETCH_TICKETS_SUCCESS: 'tickets/FETCH_TICKETS_SUCCESS',
  FETCH_TICKETS_FAILED: 'tickets/FETCH_TICKETS_FAILED',

  UPLOAD_TICKETS_START: 'tickets/UPLOAD_TICKETS_START',
  UPLOAD_TICKETS_SUCCESS: 'tickets/UPLOAD_TICKETS_SUCCESS',
  UPLOAD_TICKETS_FAILED: 'tickets/UPLOAD_TICKETS_FAILED'
};
